<div echarts [options]="chartOptions" class="chart" style="height: 400px;"></div>